import actions from "./actions";

const initialState = {
  error: null,
  loading: false,
  crawler: {},
};

export default function crawlAdditionalRequestReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CRAWL_ADDITIONAL_REQUEST_REQUEST:
      return {
        ...state,
        loading: true,
        crawler: {},
      };
    case actions.CRAWL_ADDITIONAL_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        crawler: action.crawler,
      };
    case actions.CRAWL_ADDITIONAL_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        crawler: {},
      };
    case actions.GET_CRAWL_ADDITIONAL_REQUEST_REQUEST:
      return {
        ...state,
        crawler: {},
      };
    case actions.GET_CRAWL_ADDITIONAL_REQUEST_SUCCESS:
      return {
        ...state,
        crawler: action.crawler,
      };
    case actions.GET_CRAWL_ADDITIONAL_REQUEST_ERROR:
      return {
        ...state,
        crawler: {},
        error: action.error,
      };
    case actions.DOWNLOAD_CRAWL_ADDITIONAL_REQUEST_REQUEST:
      return {
        ...state,
      };
    case actions.DOWNLOAD_CRAWL_ADDITIONAL_REQUEST_SUCCESS:
      return {
        ...state,
        crawler: action.crawler,
      };
    case actions.DOWNLOAD_CRAWL_ADDITIONAL_REQUEST_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
